
import React, { useState, useContext ,useEffect,useRef} from 'react';
import FlowBuilder, {
  NodeContext,
  INode,
} from 'react-custom-flow-builder';
import { useDispatch, useSelector } from 'react-redux';
import './FlowBuilder.css';

// import {RegisterNodes} from './utils/registerNodes'
import ConfigForm from '../../components/FlowBuiderPanels/ConfigPanel';
import AutomationConfigPanel from '../../components/FlowBuiderPanels/AutomationConfigPanel';
import ActionPanel from '../../components/FlowBuiderPanels/ActionPanel';
import "antd/dist/antd.css";
import RN_Data from "./registeredNodes.json";
import {  Modal } from 'antd';
import arrow from '../../assets/images/icons8-right-96.png'
import { LinkOutlined,UploadOutlined } from '@ant-design/icons';
import { getRNData,createFlow,getFlow,updateFlow,createDeployment,triggerTerraFormPipeline, getDefaultFlow, getEnvList } from '../../apis/flowBuilderApi/flowBuilderApi';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import startIcon from "../../assets/icons/startIcon.svg";
import endIcon from "../../assets/icons/endIcon.svg";
import Status from './status';
import { setPreferences,setEnvListData, setInstanceListData } from '../../app/slice/flowBuilderSlice';
import { getAllClientsList } from '../../apis/tenantApi/tenantApi';


const NodeForm = (props:any) => {
  const dispatch = useDispatch();

  const sampleNodes = [
    {
      id: 'node-0d9d4733-e48c-41fd-a41f-d93cc4718d97',
      type: 'start',
      name: 'Start',
      iconUrl:startIcon,
      iconBgColor:"#F6780D",
      path: ['0'],
    },
    {
      id: 'node-b106675a-5148-4a2e-aa86-8e06abd692d1',
      type: 'end',
      name: 'End',
      iconUrl:endIcon,
      iconBgColor:"#6B6B6C",
      path: ['3'],
    },
  ];

   const sampleNodesFull =[
    {
        "Id": 1000,
        "parentId": 0,
        "type": "start",
        "name": "Start",
        "displayComponent": "start",
        "isStart": true,
        "isEnd": false,
        "configComponent": "",
        "conditionNodeType": "",
        "className": "",
        "iconUrl": "/static/media/startIcon.a28930613a3f1129a988bc0e82f5941d.svg",
        "iconBgColor": "#F6780D",
        "displayname": "Start",
        "category": "",
        "categoryOptionValue": "",
        "Record_Typ": "node",
        "value": "",
        "label": "",
        "teraFrSameAsValue": "N",
        "Active_Flg": "Y",
        "usedInFE": "N",
        "c_id": null,
        "Terraform_Generated_Key": "N",
        "Key_Location": null,
        "Key_Vault_Type": null,
        "Admin_Type": null,
        "path": [
            "0"
        ],
        "id": "0"
    },
    {
        "id": "1",
        "type": "branch",
        "name": "new branch",
        "children": [
            {
                "id": "node-b878cb33-43da-43cb-954b-18432e3a2936",
                "type": "condition",
                "name": "Preferences",
                "displayName": "Preferences",
                "className": "node",
                "iconUrl": "https://adminzing.blob.core.windows.net/icon/Preferences.png",
                "iconBgColor": "#1BCCBA",
                "configElements": [
                    {
                        "Id": 1284,
                        "parentId": 1006,
                        "type": "radio",
                        "name": "Deployment",
                        "displayComponent": "",
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Full Deployment",
                        "category": "",
                        "categoryOptionValue": "",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "Deployment Type",
                        "teraFrSameAsValue": "N",
                        "Active_Flg": "Y",
                        "usedInFE": "N",
                        "c_id": null,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": null,
                        "Key_Vault_Type": null,
                        "Admin_Type": null,
                        "data": [
                            {
                                "Id": 1289,
                                "parentId": 1284,
                                "type": "radio",
                                "name": "",
                                "displayComponent": "",
                                "isStart": false,
                                "isEnd": false,
                                "configComponent": "",
                                "conditionNodeType": "",
                                "className": "",
                                "iconUrl": "",
                                "iconBgColor": "",
                                "displayname": "",
                                "category": "",
                                "categoryOptionValue": "",
                                "Record_Typ": "field",
                                "value": "Y",
                                "label": "Environment",
                                "teraFrSameAsValue": "Y",
                                "Active_Flg": "Y",
                                "usedInFE": "N",
                                "c_id": null,
                                "Terraform_Generated_Key": "N",
                                "Key_Location": null,
                                "Key_Vault_Type": null,
                                "Admin_Type": null
                            },
                            {
                                "Id": 1290,
                                "parentId": 1284,
                                "type": "radio",
                                "name": "",
                                "displayComponent": "",
                                "isStart": false,
                                "isEnd": false,
                                "configComponent": "",
                                "conditionNodeType": "",
                                "className": "",
                                "iconUrl": "",
                                "iconBgColor": "",
                                "displayname": "",
                                "category": "",
                                "categoryOptionValue": "",
                                "Record_Typ": "field",
                                "value": "N",
                                "label": "Tenant",
                                "teraFrSameAsValue": "Y",
                                "Active_Flg": "Y",
                                "usedInFE": "N",
                                "c_id": null,
                                "Terraform_Generated_Key": "N",
                                "Key_Location": null,
                                "Key_Vault_Type": null,
                                "Admin_Type": null
                            }
                        ]
                    },
                    {
                        "Id": 1286,
                        "parentId": 1006,
                        "type": "dropdown",
                        "name": "Communication_Service_Provider",
                        "displayComponent": "",
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Communication Service Provider",
                        "category": "",
                        "categoryOptionValue": "",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "",
                        "teraFrSameAsValue": "N",
                        "Active_Flg": "Y",
                        "usedInFE": "N",
                        "c_id": null,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": null,
                        "Key_Vault_Type": null,
                        "Admin_Type": null,
                        "data": [
                            {
                                "Id": 1292,
                                "parentId": 1286,
                                "type": "dropdown",
                                "name": "",
                                "displayComponent": "",
                                "isStart": false,
                                "isEnd": false,
                                "configComponent": "",
                                "conditionNodeType": "",
                                "className": "",
                                "iconUrl": "",
                                "iconBgColor": "",
                                "displayname": "Communication Service Provider",
                                "category": "",
                                "categoryOptionValue": "",
                                "Record_Typ": "field",
                                "value": "Twilio",
                                "label": "Twilio",
                                "teraFrSameAsValue": "N",
                                "Active_Flg": "Y",
                                "usedInFE": "N",
                                "c_id": null,
                                "Terraform_Generated_Key": "N",
                                "Key_Location": null,
                                "Key_Vault_Type": null,
                                "Admin_Type": null
                            }
                        ]
                    },
                    {
                        "Id": 1072,
                        "parentId": 1006,
                        "type": "text",
                        "name": "twilio_account_authtoken",
                        "displayComponent": "",
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Account Authtoken",
                        "category": "Communication_Service_Provider",
                        "categoryOptionValue": "Twilio",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "",
                        "teraFrSameAsValue": "Y",
                        "Active_Flg": "Y",
                        "usedInFE": "N",
                        "c_id": 1292,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": "keyvault",
                        "Key_Vault_Type": "Client",
                        "Admin_Type": "Global"
                    },
                    {
                        "Id": 1073,
                        "parentId": 1006,
                        "type": "text",
                        "name": "twilio_account_sid",
                        "displayComponent": "",
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Account SID",
                        "category": "Communication_Service_Provider",
                        "categoryOptionValue": "Twilio",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "",
                        "teraFrSameAsValue": "Y",
                        "Active_Flg": "Y",
                        "usedInFE": "N",
                        "c_id": 1292,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": "keyvault",
                        "Key_Vault_Type": "Client",
                        "Admin_Type": "Global"
                    },
                    {
                        "Id": 1077,
                        "parentId": 1006,
                        "type": "text",
                        "name": "twilio_twiml_app_sid",
                        "displayComponent": "",
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Twilio Twiml App SID",
                        "category": "Communication_Service_Provider",
                        "categoryOptionValue": "Twilio",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "",
                        "teraFrSameAsValue": "Y",
                        "Active_Flg": "Y",
                        "usedInFE": "N",
                        "c_id": 1292,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": "keyvault",
                        "Key_Vault_Type": "Client",
                        "Admin_Type": "Global"
                    },
                    {
                        "Id": 1078,
                        "parentId": 1006,
                        "type": "text",
                        "name": "twilio_help_message",
                        "displayComponent": "",
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Twilio Help Message",
                        "category": "Twilio",
                        "categoryOptionValue": "Communication_Service_Provider",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "",
                        "teraFrSameAsValue": "Y",
                        "Active_Flg": "Y",
                        "usedInFE": "N",
                        "c_id": 1292,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": "DB",
                        "Key_Vault_Type": "Client",
                        "Admin_Type": "Application"
                    },
                    {
                        "Id": 1079,
                        "parentId": 1006,
                        "type": "text",
                        "name": "twilio_voice_api_key",
                        "displayComponent": "",
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Voice API Key",
                        "category": "Communication_Service_Provider",
                        "categoryOptionValue": "Twilio",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "",
                        "teraFrSameAsValue": "Y",
                        "Active_Flg": "Y",
                        "usedInFE": "N",
                        "c_id": 1292,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": "keyvault",
                        "Key_Vault_Type": "Client",
                        "Admin_Type": "Global"
                    },
                    {
                        "Id": 1080,
                        "parentId": 1006,
                        "type": "text",
                        "name": "twilio_opt_in_message",
                        "displayComponent": "",
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Twilio Opt In Message",
                        "category": "Twilio",
                        "categoryOptionValue": "Communication_Service_Provider",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "",
                        "teraFrSameAsValue": "Y",
                        "Active_Flg": "Y",
                        "usedInFE": "N",
                        "c_id": 1292,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": "DB",
                        "Key_Vault_Type": "Client",
                        "Admin_Type": "Application"
                    },
                    {
                        "Id": 1081,
                        "parentId": 1006,
                        "type": "text",
                        "name": "twilio_voice_api_secret",
                        "displayComponent": "",
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Voice API Secret",
                        "category": "Communication_Service_Provider",
                        "categoryOptionValue": "Twilio",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "",
                        "teraFrSameAsValue": "Y",
                        "Active_Flg": "Y",
                        "usedInFE": "N",
                        "c_id": 1292,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": "keyvault",
                        "Key_Vault_Type": "Client",
                        "Admin_Type": "Global"
                    },
                    {
                        "Id": 1082,
                        "parentId": 1006,
                        "type": "text",
                        "name": "twilio_opt_out_message",
                        "displayComponent": "",
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Twilio Opt Out Message",
                        "category": "Twilio",
                        "categoryOptionValue": "Communication_Service_Provider",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "",
                        "teraFrSameAsValue": "Y",
                        "Active_Flg": "Y",
                        "usedInFE": "N",
                        "c_id": 1292,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": "DB",
                        "Key_Vault_Type": "Client",
                        "Admin_Type": "Application"
                    },
                    {
                        "Id": 1408,
                        "parentId": 1006,
                        "type": "text",
                        "name": "twilio_image_file_size_limit",
                        "displayComponent": null,
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Twilio Image File Size Limit",
                        "category": "",
                        "categoryOptionValue": "",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "",
                        "teraFrSameAsValue": "Y",
                        "Active_Flg": "Y",
                        "usedInFE": "N",
                        "c_id": 1292,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": "keyvault",
                        "Key_Vault_Type": "Common",
                        "Admin_Type": "Global"
                    },
                    {
                        "Id": 1409,
                        "parentId": 1006,
                        "type": "text",
                        "name": "twilio_phonenumber_form_otp",
                        "displayComponent": null,
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Twilio Phone Number Form OTP",
                        "category": "",
                        "categoryOptionValue": "",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "",
                        "teraFrSameAsValue": "Y",
                        "Active_Flg": "Y",
                        "usedInFE": "N",
                        "c_id": 1292,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": "keyvault",
                        "Key_Vault_Type": "Client",
                        "Admin_Type": "Global"
                    },
                    {
                        "Id": 1410,
                        "parentId": 1006,
                        "type": "text",
                        "name": "twilio_sms_bot_response_url",
                        "displayComponent": null,
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Twilio SMS Bot Response URL",
                        "category": "",
                        "categoryOptionValue": "",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "",
                        "teraFrSameAsValue": "Y",
                        "Active_Flg": "Y",
                        "usedInFE": "N",
                        "c_id": 1292,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": "keyvault",
                        "Key_Vault_Type": "Client",
                        "Admin_Type": "Global"
                    },
                    {
                        "Id": 1495,
                        "parentId": 1006,
                        "type": "radio",
                        "name": "environmentType",
                        "displayComponent": "",
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Environment Type",
                        "category": "",
                        "categoryOptionValue": "",
                        "Record_Typ": "property",
                        "value": "Y",
                        "label": "Environment Type",
                        "teraFrSameAsValue": "Y",
                        "Active_Flg": "Y",
                        "usedInFE": "N",
                        "c_id": 1289,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": "DB (ADMIN)",
                        "Key_Vault_Type": "Common",
                        "Admin_Type": "Application",
                        "data": [
                            {
                                "Id": 1496,
                                "parentId": 1495,
                                "type": "radio",
                                "name": "Default",
                                "displayComponent": "",
                                "isStart": false,
                                "isEnd": false,
                                "configComponent": "",
                                "conditionNodeType": "",
                                "className": "",
                                "iconUrl": "",
                                "iconBgColor": "",
                                "displayname": "Default",
                                "category": "",
                                "categoryOptionValue": "",
                                "Record_Typ": "field",
                                "value": "Y",
                                "label": "Default",
                                "teraFrSameAsValue": "N",
                                "Active_Flg": "Y",
                                "usedInFE": "N",
                                "c_id": 1495,
                                "Terraform_Generated_Key": "N",
                                "Key_Location": "DB (ADMIN)",
                                "Key_Vault_Type": "Common",
                                "Admin_Type": "Application"
                            },
                            {
                                "Id": 1497,
                                "parentId": 1495,
                                "type": "radio",
                                "name": "custom",
                                "displayComponent": "",
                                "isStart": false,
                                "isEnd": false,
                                "configComponent": "",
                                "conditionNodeType": "",
                                "className": "",
                                "iconUrl": "",
                                "iconBgColor": "",
                                "displayname": "Custom",
                                "category": "",
                                "categoryOptionValue": "",
                                "Record_Typ": "field",
                                "value": "N",
                                "label": "Custom",
                                "teraFrSameAsValue": "N",
                                "Active_Flg": "Y",
                                "usedInFE": "N",
                                "c_id": 1495,
                                "Terraform_Generated_Key": "N",
                                "Key_Location": "DB (ADMIN)",
                                "Key_Vault_Type": "Common",
                                "Admin_Type": "Application"
                            }
                        ]
                    },
                    {
                        "Id": 1031,
                        "parentId": 1006,
                        "type": "text",
                        "name": "react_app_ad_clientid",
                        "displayComponent": "",
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Ad Clientid",
                        "category": "",
                        "categoryOptionValue": "",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "",
                        "teraFrSameAsValue": "Y",
                        "Active_Flg": "Y",
                        "usedInFE": "Y",
                        "c_id": 1304,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": "keyvault",
                        "Key_Vault_Type": "Client",
                        "Admin_Type": "Global"
                    },
                    {
                        "Id": 1032,
                        "parentId": 1006,
                        "type": "text",
                        "name": "react_app_ad_redirect_url",
                        "displayComponent": "",
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Ad Redirect Url",
                        "category": "",
                        "categoryOptionValue": "",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "",
                        "teraFrSameAsValue": "Y",
                        "Active_Flg": "Y",
                        "usedInFE": "Y",
                        "c_id": 1304,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": "keyvault",
                        "Key_Vault_Type": "Client",
                        "Admin_Type": "Global"
                    },
                    {
                        "Id": 1033,
                        "parentId": 1006,
                        "type": "text",
                        "name": "react_app_android_redirect_uri",
                        "displayComponent": "",
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Android Redirect Uri",
                        "category": "",
                        "categoryOptionValue": "",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "",
                        "teraFrSameAsValue": "Y",
                        "Active_Flg": "Y",
                        "usedInFE": "Y",
                        "c_id": 1304,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": "keyvault",
                        "Key_Vault_Type": "Client",
                        "Admin_Type": "Global"
                    },
                    {
                        "Id": 1314,
                        "parentId": 1006,
                        "type": "text",
                        "name": "react_app_ad_client_secret",
                        "displayComponent": "",
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Ad Secret",
                        "category": "",
                        "categoryOptionValue": "",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "",
                        "teraFrSameAsValue": "N",
                        "Active_Flg": "Y",
                        "usedInFE": "N",
                        "c_id": 1304,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": null,
                        "Key_Vault_Type": null,
                        "Admin_Type": null
                    },
                    {
                        "Id": 1328,
                        "parentId": 1006,
                        "type": "text",
                        "name": "ad_userinfo_endpoint",
                        "displayComponent": null,
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "AD Userinfo Endpoint",
                        "category": "",
                        "categoryOptionValue": "",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "",
                        "teraFrSameAsValue": "Y",
                        "Active_Flg": "Y",
                        "usedInFE": "N",
                        "c_id": 1304,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": "keyvault",
                        "Key_Vault_Type": "Common",
                        "Admin_Type": "Global"
                    },
                    {
                        "Id": 1419,
                        "parentId": 1006,
                        "type": "text",
                        "name": "azure_ad_redirect_url",
                        "displayComponent": null,
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Azure AD Redirect URL",
                        "category": "",
                        "categoryOptionValue": "",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "",
                        "teraFrSameAsValue": "Y",
                        "Active_Flg": "Y",
                        "usedInFE": "N",
                        "c_id": 1304,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": "keyvault",
                        "Key_Vault_Type": "Client",
                        "Admin_Type": "Global"
                    },
                    {
                        "Id": 1026,
                        "parentId": 1006,
                        "type": "text",
                        "name": "azure_tenant_id",
                        "displayComponent": "",
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Azure Tenant Id of the Client Tenant",
                        "category": "",
                        "categoryOptionValue": "",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "",
                        "teraFrSameAsValue": "N",
                        "Active_Flg": "Y",
                        "usedInFE": "N",
                        "c_id": null,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": null,
                        "Key_Vault_Type": null,
                        "Admin_Type": null
                    },
                    {
                        "Id": 1027,
                        "parentId": 1006,
                        "type": "text",
                        "name": "azure_client_id",
                        "displayComponent": "",
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Azure Client Id of the Client Tenant",
                        "category": "",
                        "categoryOptionValue": "",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "",
                        "teraFrSameAsValue": "N",
                        "Active_Flg": "Y",
                        "usedInFE": "N",
                        "c_id": null,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": null,
                        "Key_Vault_Type": null,
                        "Admin_Type": null
                    },
                    {
                        "Id": 1028,
                        "parentId": 1006,
                        "type": "text",
                        "name": "azure_client_secret",
                        "displayComponent": "",
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Azure Client Secret of the Client Tenant",
                        "category": "",
                        "categoryOptionValue": "",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "",
                        "teraFrSameAsValue": "N",
                        "Active_Flg": "Y",
                        "usedInFE": "N",
                        "c_id": null,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": null,
                        "Key_Vault_Type": null,
                        "Admin_Type": null
                    },
                    {
                        "Id": 1294,
                        "parentId": 1006,
                        "type": "dropdown",
                        "name": "Authentication_Type",
                        "displayComponent": "",
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Authentication Type",
                        "category": "",
                        "categoryOptionValue": "",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "",
                        "teraFrSameAsValue": "N",
                        "Active_Flg": "Y",
                        "usedInFE": "N",
                        "c_id": null,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": null,
                        "Key_Vault_Type": null,
                        "Admin_Type": null,
                        "data": [
                            {
                                "Id": 1304,
                                "parentId": 1294,
                                "type": "dropdown",
                                "name": "",
                                "displayComponent": "",
                                "isStart": false,
                                "isEnd": false,
                                "configComponent": "",
                                "conditionNodeType": "",
                                "className": "",
                                "iconUrl": "",
                                "iconBgColor": "",
                                "displayname": "Authentication Type",
                                "category": "",
                                "categoryOptionValue": "",
                                "Record_Typ": "field",
                                "value": "AD",
                                "label": "AD",
                                "teraFrSameAsValue": "Y",
                                "Active_Flg": "Y",
                                "usedInFE": "N",
                                "c_id": null,
                                "Terraform_Generated_Key": "N",
                                "Key_Location": null,
                                "Key_Vault_Type": null,
                                "Admin_Type": null
                            }
                        ]
                    },
                    {
                        "Id": 1491,
                        "parentId": 1006,
                        "type": "text",
                        "name": "tf_pipeline_storage_acc",
                        "displayComponent": "",
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Terraform Pipeline Storage Name",
                        "category": "",
                        "categoryOptionValue": "",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "",
                        "teraFrSameAsValue": "Y",
                        "Active_Flg": "Y",
                        "usedInFE": "N",
                        "c_id": null,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": "DB (ADMIN)",
                        "Key_Vault_Type": "Client",
                        "Admin_Type": "Global"
                    },
                    {
                        "Id": 1492,
                        "parentId": 1006,
                        "type": "text",
                        "name": "tf_pipeline_storage_container",
                        "displayComponent": "",
                        "isStart": false,
                        "isEnd": false,
                        "configComponent": "",
                        "conditionNodeType": "",
                        "className": "",
                        "iconUrl": "",
                        "iconBgColor": "",
                        "displayname": "Terraform Pipeline Storage Container",
                        "category": "",
                        "categoryOptionValue": "",
                        "Record_Typ": "property",
                        "value": "",
                        "label": "",
                        "teraFrSameAsValue": "Y",
                        "Active_Flg": "Y",
                        "usedInFE": "N",
                        "c_id": null,
                        "Terraform_Generated_Key": "N",
                        "Key_Location": "DB (ADMIN)",
                        "Key_Vault_Type": "Client",
                        "Admin_Type": "Global"
                    }
                ],
                "children": [
                    {
                        "id": "branch-9906ee82-dede-4782-b072-cc736de66203",
                        "type": "branch",
                        "name": "new branch",
                        "children": [
                            {
                                "id": "node-a16e902a-5fda-40a7-ad87-16228ea3b1d7",
                                "type": "condition",
                                "name": "Client Details",
                                "displayName": "Client Details",
                                "className": "feature",
                                "iconUrl": "https://adminzing.blob.core.windows.net/icon/Group7882.png",
                                "iconBgColor": "#6A45C0",
                                "configElements": [
                                    {
                                        "Id": 1023,
                                        "parentId": 1007,
                                        "type": "text",
                                        "name": "service_connection",
                                        "displayComponent": "",
                                        "isStart": false,
                                        "isEnd": false,
                                        "configComponent": "",
                                        "conditionNodeType": "",
                                        "className": "",
                                        "iconUrl": "",
                                        "iconBgColor": "",
                                        "displayname": "Service Connection",
                                        "category": "",
                                        "categoryOptionValue": "",
                                        "Record_Typ": "property",
                                        "value": "",
                                        "label": "",
                                        "teraFrSameAsValue": "N",
                                        "Active_Flg": "Y",
                                        "usedInFE": "N",
                                        "c_id": null,
                                        "Terraform_Generated_Key": "N",
                                        "Key_Location": null,
                                        "Key_Vault_Type": null,
                                        "Admin_Type": null
                                    },
                                    {
                                        "Id": 1034,
                                        "parentId": 1007,
                                        "type": "text",
                                        "name": "react_app_auth_session_validity_minute",
                                        "displayComponent": "",
                                        "isStart": false,
                                        "isEnd": false,
                                        "configComponent": "",
                                        "conditionNodeType": "",
                                        "className": "",
                                        "iconUrl": "",
                                        "iconBgColor": "",
                                        "displayname": "Auth Session Validity Minute",
                                        "category": "",
                                        "categoryOptionValue": "",
                                        "Record_Typ": "property",
                                        "value": "",
                                        "label": "",
                                        "teraFrSameAsValue": "Y",
                                        "Active_Flg": "Y",
                                        "usedInFE": "N",
                                        "c_id": null,
                                        "Terraform_Generated_Key": "N",
                                        "Key_Location": "keyvault",
                                        "Key_Vault_Type": "Client",
                                        "Admin_Type": "Global"
                                    },
                                    {
                                        "Id": 1106,
                                        "parentId": 1007,
                                        "type": "dropdown",
                                        "name": "service_location",
                                        "displayComponent": "",
                                        "isStart": false,
                                        "isEnd": false,
                                        "configComponent": "",
                                        "conditionNodeType": "",
                                        "className": "",
                                        "iconUrl": "",
                                        "iconBgColor": "",
                                        "displayname": "Location",
                                        "category": "",
                                        "categoryOptionValue": "",
                                        "Record_Typ": "property",
                                        "value": "",
                                        "label": "",
                                        "teraFrSameAsValue": "N",
                                        "Active_Flg": "Y",
                                        "usedInFE": "N",
                                        "c_id": null,
                                        "Terraform_Generated_Key": "N",
                                        "Key_Location": null,
                                        "Key_Vault_Type": null,
                                        "Admin_Type": null,
                                        "data": [
                                            {
                                                "Id": 1107,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "eastus",
                                                "label": "East US",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1108,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "eastus2",
                                                "label": "East US 2",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1109,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "southcentralus",
                                                "label": "South Central US",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1110,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "westus2",
                                                "label": "West US 2",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1111,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "westus3",
                                                "label": "West US 3",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1112,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "southeastasia",
                                                "label": "Southeast Asia",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1113,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "northeurope",
                                                "label": "North Europe",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1114,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "uksouth",
                                                "label": "UK South",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1115,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "westeurope",
                                                "label": "West Europe",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1117,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "centralus",
                                                "label": "Central US",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1118,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "westus",
                                                "label": "West US",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1119,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "southafricanorth",
                                                "label": "South Africa North",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1120,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "centralindia",
                                                "label": "Central India",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1121,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "eastasia",
                                                "label": "East Asia",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1123,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "japaneast",
                                                "label": "Japan East",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1125,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "koreacentral",
                                                "label": "Korea Central",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1126,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "canadacentral",
                                                "label": "Canada Central",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1127,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "francecentral",
                                                "label": "France Central",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1131,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "germanywestcentral",
                                                "label": "Germany West Central",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1132,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "norwayeast",
                                                "label": "Norway East",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1133,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "switzerlandnorth",
                                                "label": "Switzerland North",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1134,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "uaenorth",
                                                "label": "UAE North",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1135,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "brazilsouth",
                                                "label": "Brazil South",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1136,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "asia",
                                                "label": "Asia",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1138,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "asiapacific",
                                                "label": "Asia Pacific",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1139,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "australia",
                                                "label": "Australia",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1140,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "brazil",
                                                "label": "Brazil",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1143,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "canada",
                                                "label": "Canada",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1144,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "europe",
                                                "label": "Europe",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1146,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "global",
                                                "label": "Global",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1147,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "india",
                                                "label": "India",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1149,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "japan",
                                                "label": "Japan",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1152,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "uk",
                                                "label": "United Kingdom",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1153,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "unitedstates",
                                                "label": "United States",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1155,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "westcentralus",
                                                "label": "West Central US",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1158,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "southafricawest",
                                                "label": "South Africa West",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1159,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "australiacentral",
                                                "label": "Australia Central",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1161,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "australiacentral2",
                                                "label": "Australia Central 2",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1164,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "australiaeast",
                                                "label": "Australia East",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1167,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "australiasoutheast",
                                                "label": "Australia Southeast",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1168,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "japanwest",
                                                "label": "Japan West",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1169,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "koreasouth",
                                                "label": "Korea South",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1170,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "southindia",
                                                "label": "South India",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1171,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "westindia",
                                                "label": "West India",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1173,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "canadaeast",
                                                "label": "Canada East",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1174,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "francesouth",
                                                "label": "France South",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1175,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "germanynorth",
                                                "label": "Germany North",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1178,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "norwaywest",
                                                "label": "Norway West",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1179,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "switzerlandwest",
                                                "label": "Switzerland West",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1180,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "ukwest",
                                                "label": "UK West",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1182,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "uaecentral",
                                                "label": "UAE Central",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1185,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "brazilsoutheast",
                                                "label": "Brazil Southeast",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1186,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "germanynortheast",
                                                "label": "Germany Northeast",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1189,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "germanycentral",
                                                "label": "Germany Central",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1191,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "chinanorth",
                                                "label": "China North",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1192,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "chinaeast",
                                                "label": "China East",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1195,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "chinaeast2",
                                                "label": "China East 2",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1198,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "chinanorth2",
                                                "label": "China North 2",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1201,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "chinaeast3",
                                                "label": "China East 3",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1202,
                                                "parentId": 1106,
                                                "type": "dropdown",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Location",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "chinanorth3",
                                                "label": "China North 3",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            }
                                        ]
                                    },
                                    {
                                        "Id": 1216,
                                        "parentId": 1007,
                                        "type": "radio",
                                        "name": "react_app_auth_session_timeout_enabled",
                                        "displayComponent": "",
                                        "isStart": false,
                                        "isEnd": false,
                                        "configComponent": "",
                                        "conditionNodeType": "",
                                        "className": "",
                                        "iconUrl": "",
                                        "iconBgColor": "",
                                        "displayname": "Auth Session Timeout Enabled",
                                        "category": "",
                                        "categoryOptionValue": "",
                                        "Record_Typ": "property",
                                        "value": "",
                                        "label": "",
                                        "teraFrSameAsValue": "Y",
                                        "Active_Flg": "Y",
                                        "usedInFE": "N",
                                        "c_id": null,
                                        "Terraform_Generated_Key": "N",
                                        "Key_Location": "keyvault",
                                        "Key_Vault_Type": "Client",
                                        "Admin_Type": "Global",
                                        "data": [
                                            {
                                                "Id": 1219,
                                                "parentId": 1216,
                                                "type": "radio",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Auth Session Timeout Enabled",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "true",
                                                "label": "Yes",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            },
                                            {
                                                "Id": 1220,
                                                "parentId": 1216,
                                                "type": "radio",
                                                "name": "",
                                                "displayComponent": "",
                                                "isStart": false,
                                                "isEnd": false,
                                                "configComponent": "",
                                                "conditionNodeType": "",
                                                "className": "",
                                                "iconUrl": "",
                                                "iconBgColor": "",
                                                "displayname": "Auth Session Timeout Enabled",
                                                "category": "",
                                                "categoryOptionValue": "",
                                                "Record_Typ": "field",
                                                "value": "false",
                                                "label": "No",
                                                "teraFrSameAsValue": "Y",
                                                "Active_Flg": "Y",
                                                "usedInFE": "N",
                                                "c_id": null,
                                                "Terraform_Generated_Key": "N",
                                                "Key_Location": null,
                                                "Key_Vault_Type": null,
                                                "Admin_Type": null
                                            }
                                        ]
                                    },
                                    {
                                        "Id": 1311,
                                        "parentId": 1007,
                                        "type": "text",
                                        "name": "rg_name",
                                        "displayComponent": "",
                                        "isStart": false,
                                        "isEnd": false,
                                        "configComponent": "",
                                        "conditionNodeType": "",
                                        "className": "",
                                        "iconUrl": "",
                                        "iconBgColor": "",
                                        "displayname": "Resource Group Name",
                                        "category": "",
                                        "categoryOptionValue": "",
                                        "Record_Typ": "property",
                                        "value": "",
                                        "label": "",
                                        "teraFrSameAsValue": "N",
                                        "Active_Flg": "Y",
                                        "usedInFE": "N",
                                        "c_id": null,
                                        "Terraform_Generated_Key": "N",
                                        "Key_Location": null,
                                        "Key_Vault_Type": null,
                                        "Admin_Type": null
                                    }
                                ],
                                "children": [
                                    {
                                        "id": "branch-cbb5286c-0b3c-46d4-93ee-011984182ade",
                                        "type": "branch",
                                        "name": "new branch",
                                        "children": [
                                            {
                                                "id": "node-70e80456-b07e-492f-94c7-ff77287543c0",
                                                "type": "condition",
                                                "name": "Env",
                                                "displayName": "Env",
                                                "className": "feature",
                                                "iconUrl": "https://adminzing.blob.core.windows.net/icon/Group7919.png",
                                                "iconBgColor": "#6A45C0",
                                                "configElements": [
                                                    {
                                                        "Id": 1049,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "react_app_logo",
                                                        "displayComponent": "",
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Logo",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1320,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "color_primary_web",
                                                        "displayComponent": "",
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Primary Color Web",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "Y",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "DB",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1321,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "color_primary_background",
                                                        "displayComponent": "",
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Primary Color Background",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "Y",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "DB",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1322,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "color_primary_light_background",
                                                        "displayComponent": "",
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Primary Color Background Light",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "Y",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "DB",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1323,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "color_index",
                                                        "displayComponent": "",
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Index Color",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "Y",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "DB",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1324,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "color_hover",
                                                        "displayComponent": "",
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Hover Color",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "Y",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "DB",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1329,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "authentication_api",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Authentication API",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1330,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "azure_blob_storage_connectionstring",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Azure Blob Storage Connection String",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1331,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "azure_blob_storage_url",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Azure Blob Storage URL",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1332,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "azure_issuer_url",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Azure Issuer URL",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1333,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "azure_storage_incomingmsg_connstring",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Azure Storage Incoming Message Connection String",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1334,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "azure_storage_incomingmsg_containername",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Azure Storage Incoming Message Container Name",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1335,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "brand_config_api_base",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Brand Config API Base",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1336,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "bundle_id",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Bundle ID",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1346,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "favicon_url",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Favicon URL",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1356,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "pushnotification_url",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Push Notification URL",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1357,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "react_app_acs_endpoint_url",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "React App ACS Endpoint URL",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1358,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "react_app_android_scope",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "React App Android Scope",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1362,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "react_app_campaign_api_base",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "React App Campaign API Base",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1364,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "react_app_contacts_api_base",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "React App Contacts API Base",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1366,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "react_app_country_list",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "React App Country List",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "DB",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Application"
                                                    },
                                                    {
                                                        "Id": 1367,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "react_app_cross_redirect_uri",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "React App Cross Redirect URI",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1368,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "react_app_default_wave_id",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "React App Default Wave ID",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "DB",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Application"
                                                    },
                                                    {
                                                        "Id": 1371,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "react_app_favicon",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "React App Favicon",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "DB",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1376,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "react_app_logo_redirect_path",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "React App Logo Redirect Path",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1398,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "redis_password",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Redis Password",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1399,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "redis_port",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Redis Port",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1401,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "shorturl_slug_char_container",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Short URL Slug Char Container",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1403,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "socket_api_base",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Socket API Base",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1404,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "sqldatabasename",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "SQL Database Name",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1405,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "sqlserver",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "SQL Server",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1406,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "sqlusername",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "SQL Username",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1407,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "superset_admin_password",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Superset Password",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1411,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "valid_file_extensions",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Valid File Extensions",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1414,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "ws_messenger_url",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "WS Messenger URL",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1415,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "zing_sms_function_help_keyword",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Zing SMS Function Help Keyword",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "DB",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Application"
                                                    },
                                                    {
                                                        "Id": 1417,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "zing_sms_function_help_url",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Zing SMS Function Help URL",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1420,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "client_name",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Client Name",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "Y",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1422,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "domain_name",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Domain Name",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1423,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "domain_url",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Domain URL",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1425,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "react_app_auth_type",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "React App Authentication Type",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1431,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "sort_filter",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Sort Filter",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "DB",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1432,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "word_list",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Word List",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "DB",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1433,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "superset_base_uri",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Superset Base URI",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1437,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "azure_blob_storage_container",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Azure Blob Storage Container",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1438,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "azure_logout_endpoint",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Azure Logout Endpoint",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1439,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "azure_token_endpoint",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Azure Token Endpoint",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1440,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "azureblobformcontainername",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Azure Blob Form Container Name",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1441,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "content_share_api_blob_conn_string",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Content Share API Blob Connection String",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1442,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "formrequestreactbaseurl",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Form Request React Base URL",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1443,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "geo_ip_account_id",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Geo IP Account ID",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1444,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "geo_ip_license_key",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Geo IP License Key",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1445,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "logger_id",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Logger ID",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1446,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "logger_pass",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Logger Password",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1447,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "sqlpassword",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "SQL Password",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1448,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "react_app_bot_api_base",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "React App Bot API Base",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1449,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "react_app_calendar_api_base",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "React App Calendar API Base",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1450,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "react_app_default_campaign_id",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "React App Default Campaign ID",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "DB",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Application"
                                                    },
                                                    {
                                                        "Id": 1451,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "react_app_default_date",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "React App Default Date",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "DB",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Application"
                                                    },
                                                    {
                                                        "Id": 1452,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "react_app_default_product_id",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "React App Default Product ID",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "DB",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Application"
                                                    },
                                                    {
                                                        "Id": 1454,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "react_app_ooo_flag",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "React App Out of Office Flag",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "DB",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Application"
                                                    },
                                                    {
                                                        "Id": 1455,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "react_app_pdftron_licensekey",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "React App PDFTron License Key",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1457,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "react_app_google_redirect_url",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "React App Google Redirect URL",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1458,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "react_app_graphme_endpoint",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "React App Graph Me Endpoint",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1459,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "react_app_incoming_content_moderation",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "React App Incoming Content Moderation",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "DB",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Application"
                                                    },
                                                    {
                                                        "Id": 1460,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "react_app_message_api",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "React App Message API",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1461,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "react_app_outgoing_content_moderation",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "React App Outgoing Content Moderation",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "DB",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Application"
                                                    },
                                                    {
                                                        "Id": 1465,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "react_app_video_api_base",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "React App Video API Base",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1466,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "redis_host",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Redis Host",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1467,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "short_url_endpoint",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Short URL Endpoint",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1468,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "twilio_non_image_file_size_limit",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Twilio Non-Image File Size Limit",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1469,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "twilio_supported_file_types",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Twilio Supported File Types",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1470,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "video_application_url",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Video Application URL",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "Y",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1471,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "video_meeting_enable_join_min",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Video Meeting Enable Join Min",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "DB",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Application"
                                                    },
                                                    {
                                                        "Id": 1472,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "env_name",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Environment Name",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "Y",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1475,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "domain",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Domain",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "DB (ADMIN)",
                                                        "Key_Vault_Type": "Common",
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1479,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "fe_keys",
                                                        "displayComponent": null,
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Frontend Keys",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "DB (ADMIN)",
                                                        "Key_Vault_Type": null,
                                                        "Admin_Type": "Global"
                                                    },
                                                    {
                                                        "Id": 1494,
                                                        "parentId": 1008,
                                                        "type": "text",
                                                        "name": "superset_dashboard_css",
                                                        "displayComponent": "",
                                                        "isStart": false,
                                                        "isEnd": false,
                                                        "configComponent": "",
                                                        "conditionNodeType": "",
                                                        "className": "",
                                                        "iconUrl": "",
                                                        "iconBgColor": "",
                                                        "displayname": "Superset Dashboard Css",
                                                        "category": "",
                                                        "categoryOptionValue": "",
                                                        "Record_Typ": "property",
                                                        "value": "",
                                                        "label": "",
                                                        "teraFrSameAsValue": "Y",
                                                        "Active_Flg": "Y",
                                                        "usedInFE": "N",
                                                        "c_id": null,
                                                        "Terraform_Generated_Key": "N",
                                                        "Key_Location": "keyvault",
                                                        "Key_Vault_Type": "Client",
                                                        "Admin_Type": "Global"
                                                    }
                                                ],
                                                "children": [
                                                    {
                                                        "id": "branch-02216845-907f-4b8c-9736-9b12ad64dfb0",
                                                        "type": "branch",
                                                        "name": "new branch",
                                                        "children": [
                                                            {
                                                                "id": "node-f79bbbfd-c402-4e93-bef1-2656170459b1",
                                                                "type": "condition",
                                                                "name": "Message",
                                                                "displayName": "Message",
                                                                "className": "feature",
                                                                "iconUrl": "https://adminzing.blob.core.windows.net/icon/Path53403.png",
                                                                "iconBgColor": "#F6780D",
                                                                "configElements": [
                                                                    {
                                                                        "Id": 1053,
                                                                        "parentId": 1009,
                                                                        "type": "text",
                                                                        "name": "event_hub_maximum_retry",
                                                                        "displayComponent": "",
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Event Hub Maximum Retry",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Common",
                                                                        "Admin_Type": "Global"
                                                                    },
                                                                    {
                                                                        "Id": 1064,
                                                                        "parentId": 1009,
                                                                        "type": "text",
                                                                        "name": "react_app_ooo_type",
                                                                        "displayComponent": "",
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "OOO Type",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "DB",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Application"
                                                                    },
                                                                    {
                                                                        "Id": 1066,
                                                                        "parentId": 1009,
                                                                        "type": "text",
                                                                        "name": "vcf_verbiage",
                                                                        "displayComponent": "",
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "VCF Verbiage",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "DB",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Application"
                                                                    },
                                                                    {
                                                                        "Id": 1255,
                                                                        "parentId": 1009,
                                                                        "type": "radio",
                                                                        "name": "content_moderator_flag",
                                                                        "displayComponent": "",
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Content Moderator Flag",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "DB",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Application",
                                                                        "data": [
                                                                            {
                                                                                "Id": 1259,
                                                                                "parentId": 1255,
                                                                                "type": "radio",
                                                                                "name": "",
                                                                                "displayComponent": "",
                                                                                "isStart": false,
                                                                                "isEnd": false,
                                                                                "configComponent": "",
                                                                                "conditionNodeType": "",
                                                                                "className": "",
                                                                                "iconUrl": "",
                                                                                "iconBgColor": "",
                                                                                "displayname": "",
                                                                                "category": "",
                                                                                "categoryOptionValue": "",
                                                                                "Record_Typ": "field",
                                                                                "value": "Y",
                                                                                "label": "Yes",
                                                                                "teraFrSameAsValue": "Y",
                                                                                "Active_Flg": "Y",
                                                                                "usedInFE": "N",
                                                                                "c_id": null,
                                                                                "Terraform_Generated_Key": "N",
                                                                                "Key_Location": null,
                                                                                "Key_Vault_Type": null,
                                                                                "Admin_Type": null
                                                                            },
                                                                            {
                                                                                "Id": 1261,
                                                                                "parentId": 1255,
                                                                                "type": "radio",
                                                                                "name": "",
                                                                                "displayComponent": "",
                                                                                "isStart": false,
                                                                                "isEnd": false,
                                                                                "configComponent": "",
                                                                                "conditionNodeType": "",
                                                                                "className": "",
                                                                                "iconUrl": "",
                                                                                "iconBgColor": "",
                                                                                "displayname": "",
                                                                                "category": "",
                                                                                "categoryOptionValue": "",
                                                                                "Record_Typ": "field",
                                                                                "value": "N",
                                                                                "label": "No",
                                                                                "teraFrSameAsValue": "Y",
                                                                                "Active_Flg": "Y",
                                                                                "usedInFE": "N",
                                                                                "c_id": null,
                                                                                "Terraform_Generated_Key": "N",
                                                                                "Key_Location": null,
                                                                                "Key_Vault_Type": null,
                                                                                "Admin_Type": null
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "Id": 1264,
                                                                        "parentId": 1009,
                                                                        "type": "radio",
                                                                        "name": "intro_required",
                                                                        "displayComponent": "",
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Intro Required",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "DB",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Application",
                                                                        "data": [
                                                                            {
                                                                                "Id": 1268,
                                                                                "parentId": 1264,
                                                                                "type": "radio",
                                                                                "name": "",
                                                                                "displayComponent": "",
                                                                                "isStart": false,
                                                                                "isEnd": false,
                                                                                "configComponent": "",
                                                                                "conditionNodeType": "",
                                                                                "className": "",
                                                                                "iconUrl": "",
                                                                                "iconBgColor": "",
                                                                                "displayname": "",
                                                                                "category": "",
                                                                                "categoryOptionValue": "",
                                                                                "Record_Typ": "field",
                                                                                "value": "true",
                                                                                "label": "Yes",
                                                                                "teraFrSameAsValue": "Y",
                                                                                "Active_Flg": "Y",
                                                                                "usedInFE": "N",
                                                                                "c_id": null,
                                                                                "Terraform_Generated_Key": "N",
                                                                                "Key_Location": null,
                                                                                "Key_Vault_Type": null,
                                                                                "Admin_Type": null
                                                                            },
                                                                            {
                                                                                "Id": 1269,
                                                                                "parentId": 1264,
                                                                                "type": "radio",
                                                                                "name": "",
                                                                                "displayComponent": "",
                                                                                "isStart": false,
                                                                                "isEnd": false,
                                                                                "configComponent": "",
                                                                                "conditionNodeType": "",
                                                                                "className": "",
                                                                                "iconUrl": "",
                                                                                "iconBgColor": "",
                                                                                "displayname": "",
                                                                                "category": "",
                                                                                "categoryOptionValue": "",
                                                                                "Record_Typ": "field",
                                                                                "value": "false",
                                                                                "label": "No",
                                                                                "teraFrSameAsValue": "Y",
                                                                                "Active_Flg": "Y",
                                                                                "usedInFE": "N",
                                                                                "c_id": null,
                                                                                "Terraform_Generated_Key": "N",
                                                                                "Key_Location": null,
                                                                                "Key_Vault_Type": null,
                                                                                "Admin_Type": null
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "Id": 1270,
                                                                        "parentId": 1009,
                                                                        "type": "radio",
                                                                        "name": "need_vcf_as_link",
                                                                        "displayComponent": "",
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Need VCF As Link",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "DB",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Application",
                                                                        "data": [
                                                                            {
                                                                                "Id": 1273,
                                                                                "parentId": 1270,
                                                                                "type": "radio",
                                                                                "name": "",
                                                                                "displayComponent": "",
                                                                                "isStart": false,
                                                                                "isEnd": false,
                                                                                "configComponent": "",
                                                                                "conditionNodeType": "",
                                                                                "className": "",
                                                                                "iconUrl": "",
                                                                                "iconBgColor": "",
                                                                                "displayname": "",
                                                                                "category": "",
                                                                                "categoryOptionValue": "",
                                                                                "Record_Typ": "field",
                                                                                "value": "true",
                                                                                "label": "Yes",
                                                                                "teraFrSameAsValue": "Y",
                                                                                "Active_Flg": "Y",
                                                                                "usedInFE": "N",
                                                                                "c_id": null,
                                                                                "Terraform_Generated_Key": "N",
                                                                                "Key_Location": null,
                                                                                "Key_Vault_Type": null,
                                                                                "Admin_Type": null
                                                                            },
                                                                            {
                                                                                "Id": 1274,
                                                                                "parentId": 1270,
                                                                                "type": "radio",
                                                                                "name": "",
                                                                                "displayComponent": "",
                                                                                "isStart": false,
                                                                                "isEnd": false,
                                                                                "configComponent": "",
                                                                                "conditionNodeType": "",
                                                                                "className": "",
                                                                                "iconUrl": "",
                                                                                "iconBgColor": "",
                                                                                "displayname": "",
                                                                                "category": "",
                                                                                "categoryOptionValue": "",
                                                                                "Record_Typ": "field",
                                                                                "value": "false",
                                                                                "label": "No",
                                                                                "teraFrSameAsValue": "Y",
                                                                                "Active_Flg": "Y",
                                                                                "usedInFE": "N",
                                                                                "c_id": null,
                                                                                "Terraform_Generated_Key": "N",
                                                                                "Key_Location": null,
                                                                                "Key_Vault_Type": null,
                                                                                "Admin_Type": null
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "Id": 1285,
                                                                        "parentId": 1009,
                                                                        "type": "radio",
                                                                        "name": "vcf_separate_attach",
                                                                        "displayComponent": "",
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "VCF Separate Attach",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "DB",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Application",
                                                                        "data": [
                                                                            {
                                                                                "Id": 1287,
                                                                                "parentId": 1285,
                                                                                "type": "radio",
                                                                                "name": "",
                                                                                "displayComponent": "",
                                                                                "isStart": false,
                                                                                "isEnd": false,
                                                                                "configComponent": "",
                                                                                "conditionNodeType": "",
                                                                                "className": "",
                                                                                "iconUrl": "",
                                                                                "iconBgColor": "",
                                                                                "displayname": "",
                                                                                "category": "",
                                                                                "categoryOptionValue": "",
                                                                                "Record_Typ": "field",
                                                                                "value": "true",
                                                                                "label": "Yes",
                                                                                "teraFrSameAsValue": "Y",
                                                                                "Active_Flg": "Y",
                                                                                "usedInFE": "N",
                                                                                "c_id": null,
                                                                                "Terraform_Generated_Key": "N",
                                                                                "Key_Location": null,
                                                                                "Key_Vault_Type": null,
                                                                                "Admin_Type": null
                                                                            },
                                                                            {
                                                                                "Id": 1288,
                                                                                "parentId": 1285,
                                                                                "type": "radio",
                                                                                "name": "",
                                                                                "displayComponent": "",
                                                                                "isStart": false,
                                                                                "isEnd": false,
                                                                                "configComponent": "",
                                                                                "conditionNodeType": "",
                                                                                "className": "",
                                                                                "iconUrl": "",
                                                                                "iconBgColor": "",
                                                                                "displayname": "",
                                                                                "category": "",
                                                                                "categoryOptionValue": "",
                                                                                "Record_Typ": "field",
                                                                                "value": "false",
                                                                                "label": "No",
                                                                                "teraFrSameAsValue": "Y",
                                                                                "Active_Flg": "Y",
                                                                                "usedInFE": "N",
                                                                                "c_id": null,
                                                                                "Terraform_Generated_Key": "N",
                                                                                "Key_Location": null,
                                                                                "Key_Vault_Type": null,
                                                                                "Admin_Type": null
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "Id": 1337,
                                                                        "parentId": 1009,
                                                                        "type": "text",
                                                                        "name": "conent_moderator_key",
                                                                        "displayComponent": null,
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Content Moderator Key",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": 1259,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Global"
                                                                    },
                                                                    {
                                                                        "Id": 1338,
                                                                        "parentId": 1009,
                                                                        "type": "text",
                                                                        "name": "content_check_url",
                                                                        "displayComponent": null,
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Content Check URL",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": 1259,
                                                                        "Terraform_Generated_Key": "Y",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Global"
                                                                    },
                                                                    {
                                                                        "Id": 1339,
                                                                        "parentId": 1009,
                                                                        "type": "text",
                                                                        "name": "content_moderator_api",
                                                                        "displayComponent": null,
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Content Moderator API",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": 1259,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Global"
                                                                    },
                                                                    {
                                                                        "Id": 1340,
                                                                        "parentId": 1009,
                                                                        "type": "text",
                                                                        "name": "content_moderator_outgoing_flag",
                                                                        "displayComponent": null,
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Content Moderator Outgoing Flag",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": 1259,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "DB",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Application"
                                                                    },
                                                                    {
                                                                        "Id": 1341,
                                                                        "parentId": 1009,
                                                                        "type": "text",
                                                                        "name": "default_template_id",
                                                                        "displayComponent": null,
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Default Template ID",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "DB",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Global"
                                                                    },
                                                                    {
                                                                        "Id": 1344,
                                                                        "parentId": 1009,
                                                                        "type": "text",
                                                                        "name": "event_hub_connection_string",
                                                                        "displayComponent": null,
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Event Hub Connection String",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "Y",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Global"
                                                                    },
                                                                    {
                                                                        "Id": 1345,
                                                                        "parentId": 1009,
                                                                        "type": "text",
                                                                        "name": "event_hub_name",
                                                                        "displayComponent": null,
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Event Hub Name",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Global"
                                                                    },
                                                                    {
                                                                        "Id": 1351,
                                                                        "parentId": 1009,
                                                                        "type": "text",
                                                                        "name": "meeting_schedular_ui_endpoint",
                                                                        "displayComponent": null,
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Meeting Scheduler UI Endpoint",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "Y",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Global"
                                                                    },
                                                                    {
                                                                        "Id": 1352,
                                                                        "parentId": 1009,
                                                                        "type": "text",
                                                                        "name": "message_first_product_as_default",
                                                                        "displayComponent": null,
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Message First Product As Default",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "DB",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Application"
                                                                    },
                                                                    {
                                                                        "Id": 1365,
                                                                        "parentId": 1009,
                                                                        "type": "text",
                                                                        "name": "react_app_content_share_api_base",
                                                                        "displayComponent": null,
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "React App Content Share API Base",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": 1259,
                                                                        "Terraform_Generated_Key": "Y",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Common",
                                                                        "Admin_Type": "Global"
                                                                    },
                                                                    {
                                                                        "Id": 1380,
                                                                        "parentId": 1009,
                                                                        "type": "text",
                                                                        "name": "react_app_ooo_response_url",
                                                                        "displayComponent": null,
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "React App OOO Response URL",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "Y",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Common",
                                                                        "Admin_Type": "Global"
                                                                    },
                                                                    {
                                                                        "Id": 1402,
                                                                        "parentId": 1009,
                                                                        "type": "text",
                                                                        "name": "sms_status_callback_url",
                                                                        "displayComponent": null,
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "SMS Status Callback URL",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "Y",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Global"
                                                                    },
                                                                    {
                                                                        "Id": 1416,
                                                                        "parentId": 1009,
                                                                        "type": "text",
                                                                        "name": "zing_sms_function_help_response",
                                                                        "displayComponent": null,
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Zing SMS Function Help Response",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "DB",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Application"
                                                                    },
                                                                    {
                                                                        "Id": 1418,
                                                                        "parentId": 1009,
                                                                        "type": "text",
                                                                        "name": "zing_sms_function_response_url",
                                                                        "displayComponent": null,
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Zing SMS Function Response URL",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "Y",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Global"
                                                                    },
                                                                    {
                                                                        "Id": 1421,
                                                                        "parentId": 1009,
                                                                        "type": "text",
                                                                        "name": "content_moderator_incoming_flag",
                                                                        "displayComponent": null,
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Content Moderator Incoming Flag",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": 1259,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "DB",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Application"
                                                                    },
                                                                    {
                                                                        "Id": 1426,
                                                                        "parentId": 1009,
                                                                        "type": "text",
                                                                        "name": "react_app_outgoing_res_content_moderation",
                                                                        "displayComponent": null,
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "React App Outgoing Response Content Moderation",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": 1259,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "DB",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Application"
                                                                    }
                                                                ],
                                                                "children": [],
                                                                "nodeDetails": {
                                                                    "nodeId": 1009,
                                                                    "parentId": 1008
                                                                },
                                                                "path": [
                                                                    "1",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0"
                                                                ]
                                                            },
                                                            {
                                                                "id": "node-d211b88d-9870-44bf-a3ed-03203648c53e",
                                                                "type": "condition",
                                                                "name": "Call",
                                                                "displayName": "Call",
                                                                "className": "feature",
                                                                "iconUrl": "https://adminzing.blob.core.windows.net/icon/Path276.png",
                                                                "iconBgColor": "#FFC107",
                                                                "configElements": [
                                                                    {
                                                                        "Id": 1083,
                                                                        "parentId": 1010,
                                                                        "type": "text",
                                                                        "name": "default_voice_mail_message",
                                                                        "displayComponent": "",
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Default Voice Mail Message",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "DB",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Application"
                                                                    },
                                                                    {
                                                                        "Id": 1354,
                                                                        "parentId": 1010,
                                                                        "type": "text",
                                                                        "name": "outbound_call_webhook_url",
                                                                        "displayComponent": null,
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Outbound Call Webhook URL",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "Y",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Global"
                                                                    },
                                                                    {
                                                                        "Id": 1361,
                                                                        "parentId": 1010,
                                                                        "type": "text",
                                                                        "name": "react_app_call_api_base",
                                                                        "displayComponent": null,
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "React App Call API Base",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "Y",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Common",
                                                                        "Admin_Type": "Global"
                                                                    }
                                                                ],
                                                                "children": [],
                                                                "nodeDetails": {
                                                                    "nodeId": 1010,
                                                                    "parentId": 1008
                                                                },
                                                                "path": [
                                                                    "1",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "1"
                                                                ]
                                                            },
                                                            {
                                                                "id": "node-f418bf9e-c2ca-4a4b-b3d3-0c3722339fd1",
                                                                "type": "condition",
                                                                "name": "Calendar",
                                                                "displayName": "Calendar",
                                                                "className": "feature",
                                                                "iconUrl": "https://adminzing.blob.core.windows.net/icon/Group7911.png",
                                                                "iconBgColor": "#1BCCBA",
                                                                "configElements": [
                                                                    {
                                                                        "Id": 1087,
                                                                        "parentId": 1011,
                                                                        "type": "text",
                                                                        "name": "google_calendar_api_key",
                                                                        "displayComponent": "",
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Google Calendar API Key",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Global"
                                                                    },
                                                                    {
                                                                        "Id": 1089,
                                                                        "parentId": 1011,
                                                                        "type": "text",
                                                                        "name": "google_client_secret",
                                                                        "displayComponent": "",
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Google Client Secret",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Global"
                                                                    },
                                                                    {
                                                                        "Id": 1091,
                                                                        "parentId": 1011,
                                                                        "type": "text",
                                                                        "name": "react_app_google_client_id",
                                                                        "displayComponent": "",
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "React App Google Client ID",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Global"
                                                                    },
                                                                    {
                                                                        "Id": 1203,
                                                                        "parentId": 1011,
                                                                        "type": "radio",
                                                                        "name": "calendar_auto_accept_events",
                                                                        "displayComponent": "",
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Calendar Auto Accept Events",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "DB",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Application",
                                                                        "data": [
                                                                            {
                                                                                "Id": 1204,
                                                                                "parentId": 1203,
                                                                                "type": "radio",
                                                                                "name": "",
                                                                                "displayComponent": "",
                                                                                "isStart": false,
                                                                                "isEnd": false,
                                                                                "configComponent": "",
                                                                                "conditionNodeType": "",
                                                                                "className": "",
                                                                                "iconUrl": "",
                                                                                "iconBgColor": "",
                                                                                "displayname": "",
                                                                                "category": "",
                                                                                "categoryOptionValue": "",
                                                                                "Record_Typ": "field",
                                                                                "value": "Y",
                                                                                "label": "Yes",
                                                                                "teraFrSameAsValue": "Y",
                                                                                "Active_Flg": "Y",
                                                                                "usedInFE": "N",
                                                                                "c_id": null,
                                                                                "Terraform_Generated_Key": "N",
                                                                                "Key_Location": null,
                                                                                "Key_Vault_Type": null,
                                                                                "Admin_Type": null
                                                                            },
                                                                            {
                                                                                "Id": 1205,
                                                                                "parentId": 1203,
                                                                                "type": "radio",
                                                                                "name": "",
                                                                                "displayComponent": "",
                                                                                "isStart": false,
                                                                                "isEnd": false,
                                                                                "configComponent": "",
                                                                                "conditionNodeType": "",
                                                                                "className": "",
                                                                                "iconUrl": "",
                                                                                "iconBgColor": "",
                                                                                "displayname": "",
                                                                                "category": "",
                                                                                "categoryOptionValue": "",
                                                                                "Record_Typ": "field",
                                                                                "value": "N",
                                                                                "label": "No",
                                                                                "teraFrSameAsValue": "Y",
                                                                                "Active_Flg": "Y",
                                                                                "usedInFE": "N",
                                                                                "c_id": null,
                                                                                "Terraform_Generated_Key": "N",
                                                                                "Key_Location": null,
                                                                                "Key_Vault_Type": null,
                                                                                "Admin_Type": null
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "Id": 1207,
                                                                        "parentId": 1011,
                                                                        "type": "radio",
                                                                        "name": "calendar_incoming_request_is_video",
                                                                        "displayComponent": "",
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Calendar Incoming Request Is Video",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "DB",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Application",
                                                                        "data": [
                                                                            {
                                                                                "Id": 1208,
                                                                                "parentId": 1207,
                                                                                "type": "radio",
                                                                                "name": "",
                                                                                "displayComponent": "",
                                                                                "isStart": false,
                                                                                "isEnd": false,
                                                                                "configComponent": "",
                                                                                "conditionNodeType": "",
                                                                                "className": "",
                                                                                "iconUrl": "",
                                                                                "iconBgColor": "",
                                                                                "displayname": "",
                                                                                "category": "",
                                                                                "categoryOptionValue": "",
                                                                                "Record_Typ": "field",
                                                                                "value": "Y",
                                                                                "label": "Yes",
                                                                                "teraFrSameAsValue": "Y",
                                                                                "Active_Flg": "Y",
                                                                                "usedInFE": "N",
                                                                                "c_id": null,
                                                                                "Terraform_Generated_Key": "N",
                                                                                "Key_Location": null,
                                                                                "Key_Vault_Type": null,
                                                                                "Admin_Type": null
                                                                            },
                                                                            {
                                                                                "Id": 1209,
                                                                                "parentId": 1207,
                                                                                "type": "radio",
                                                                                "name": "",
                                                                                "displayComponent": "",
                                                                                "isStart": false,
                                                                                "isEnd": false,
                                                                                "configComponent": "",
                                                                                "conditionNodeType": "",
                                                                                "className": "",
                                                                                "iconUrl": "",
                                                                                "iconBgColor": "",
                                                                                "displayname": "",
                                                                                "category": "",
                                                                                "categoryOptionValue": "",
                                                                                "Record_Typ": "field",
                                                                                "value": "N",
                                                                                "label": "No",
                                                                                "teraFrSameAsValue": "Y",
                                                                                "Active_Flg": "Y",
                                                                                "usedInFE": "N",
                                                                                "c_id": null,
                                                                                "Terraform_Generated_Key": "N",
                                                                                "Key_Location": null,
                                                                                "Key_Vault_Type": null,
                                                                                "Admin_Type": null
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "Id": 1211,
                                                                        "parentId": 1011,
                                                                        "type": "radio",
                                                                        "name": "outlook_sync_all",
                                                                        "displayComponent": "",
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Outlook Sync All",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "DB",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Application",
                                                                        "data": [
                                                                            {
                                                                                "Id": 1214,
                                                                                "parentId": 1211,
                                                                                "type": "radio",
                                                                                "name": "",
                                                                                "displayComponent": "",
                                                                                "isStart": false,
                                                                                "isEnd": false,
                                                                                "configComponent": "",
                                                                                "conditionNodeType": "",
                                                                                "className": "",
                                                                                "iconUrl": "",
                                                                                "iconBgColor": "",
                                                                                "displayname": "",
                                                                                "category": "",
                                                                                "categoryOptionValue": "",
                                                                                "Record_Typ": "field",
                                                                                "value": "Y",
                                                                                "label": "Yes",
                                                                                "teraFrSameAsValue": "Y",
                                                                                "Active_Flg": "Y",
                                                                                "usedInFE": "N",
                                                                                "c_id": null,
                                                                                "Terraform_Generated_Key": "N",
                                                                                "Key_Location": null,
                                                                                "Key_Vault_Type": null,
                                                                                "Admin_Type": null
                                                                            },
                                                                            {
                                                                                "Id": 1215,
                                                                                "parentId": 1211,
                                                                                "type": "radio",
                                                                                "name": "",
                                                                                "displayComponent": "",
                                                                                "isStart": false,
                                                                                "isEnd": false,
                                                                                "configComponent": "",
                                                                                "conditionNodeType": "",
                                                                                "className": "",
                                                                                "iconUrl": "",
                                                                                "iconBgColor": "",
                                                                                "displayname": "",
                                                                                "category": "",
                                                                                "categoryOptionValue": "",
                                                                                "Record_Typ": "field",
                                                                                "value": "N",
                                                                                "label": "No",
                                                                                "teraFrSameAsValue": "Y",
                                                                                "Active_Flg": "Y",
                                                                                "usedInFE": "N",
                                                                                "c_id": null,
                                                                                "Terraform_Generated_Key": "N",
                                                                                "Key_Location": null,
                                                                                "Key_Vault_Type": null,
                                                                                "Admin_Type": null
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "Id": 1428,
                                                                        "parentId": 1011,
                                                                        "type": "text",
                                                                        "name": "sync_type",
                                                                        "displayComponent": null,
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Sync Type",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Global"
                                                                    }
                                                                ],
                                                                "children": [],
                                                                "nodeDetails": {
                                                                    "nodeId": 1011,
                                                                    "parentId": 1008
                                                                },
                                                                "path": [
                                                                    "1",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "2"
                                                                ]
                                                            },
                                                            {
                                                                "id": "node-c604a436-e6b2-4ebb-a5f0-a84a6faec1a0",
                                                                "type": "condition",
                                                                "name": "Calendar",
                                                                "displayName": "Calendar",
                                                                "className": "feature",
                                                                "iconUrl": "https://adminzing.blob.core.windows.net/icon/Group7911.png",
                                                                "iconBgColor": "#1BCCBA",
                                                                "configElements": [
                                                                    {
                                                                        "Id": 1087,
                                                                        "parentId": 1011,
                                                                        "type": "text",
                                                                        "name": "google_calendar_api_key",
                                                                        "displayComponent": "",
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Google Calendar API Key",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Global"
                                                                    },
                                                                    {
                                                                        "Id": 1089,
                                                                        "parentId": 1011,
                                                                        "type": "text",
                                                                        "name": "google_client_secret",
                                                                        "displayComponent": "",
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Google Client Secret",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Global"
                                                                    },
                                                                    {
                                                                        "Id": 1091,
                                                                        "parentId": 1011,
                                                                        "type": "text",
                                                                        "name": "react_app_google_client_id",
                                                                        "displayComponent": "",
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "React App Google Client ID",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Global"
                                                                    },
                                                                    {
                                                                        "Id": 1203,
                                                                        "parentId": 1011,
                                                                        "type": "radio",
                                                                        "name": "calendar_auto_accept_events",
                                                                        "displayComponent": "",
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Calendar Auto Accept Events",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "DB",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Application",
                                                                        "data": [
                                                                            {
                                                                                "Id": 1204,
                                                                                "parentId": 1203,
                                                                                "type": "radio",
                                                                                "name": "",
                                                                                "displayComponent": "",
                                                                                "isStart": false,
                                                                                "isEnd": false,
                                                                                "configComponent": "",
                                                                                "conditionNodeType": "",
                                                                                "className": "",
                                                                                "iconUrl": "",
                                                                                "iconBgColor": "",
                                                                                "displayname": "",
                                                                                "category": "",
                                                                                "categoryOptionValue": "",
                                                                                "Record_Typ": "field",
                                                                                "value": "Y",
                                                                                "label": "Yes",
                                                                                "teraFrSameAsValue": "Y",
                                                                                "Active_Flg": "Y",
                                                                                "usedInFE": "N",
                                                                                "c_id": null,
                                                                                "Terraform_Generated_Key": "N",
                                                                                "Key_Location": null,
                                                                                "Key_Vault_Type": null,
                                                                                "Admin_Type": null
                                                                            },
                                                                            {
                                                                                "Id": 1205,
                                                                                "parentId": 1203,
                                                                                "type": "radio",
                                                                                "name": "",
                                                                                "displayComponent": "",
                                                                                "isStart": false,
                                                                                "isEnd": false,
                                                                                "configComponent": "",
                                                                                "conditionNodeType": "",
                                                                                "className": "",
                                                                                "iconUrl": "",
                                                                                "iconBgColor": "",
                                                                                "displayname": "",
                                                                                "category": "",
                                                                                "categoryOptionValue": "",
                                                                                "Record_Typ": "field",
                                                                                "value": "N",
                                                                                "label": "No",
                                                                                "teraFrSameAsValue": "Y",
                                                                                "Active_Flg": "Y",
                                                                                "usedInFE": "N",
                                                                                "c_id": null,
                                                                                "Terraform_Generated_Key": "N",
                                                                                "Key_Location": null,
                                                                                "Key_Vault_Type": null,
                                                                                "Admin_Type": null
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "Id": 1207,
                                                                        "parentId": 1011,
                                                                        "type": "radio",
                                                                        "name": "calendar_incoming_request_is_video",
                                                                        "displayComponent": "",
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Calendar Incoming Request Is Video",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "DB",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Application",
                                                                        "data": [
                                                                            {
                                                                                "Id": 1208,
                                                                                "parentId": 1207,
                                                                                "type": "radio",
                                                                                "name": "",
                                                                                "displayComponent": "",
                                                                                "isStart": false,
                                                                                "isEnd": false,
                                                                                "configComponent": "",
                                                                                "conditionNodeType": "",
                                                                                "className": "",
                                                                                "iconUrl": "",
                                                                                "iconBgColor": "",
                                                                                "displayname": "",
                                                                                "category": "",
                                                                                "categoryOptionValue": "",
                                                                                "Record_Typ": "field",
                                                                                "value": "Y",
                                                                                "label": "Yes",
                                                                                "teraFrSameAsValue": "Y",
                                                                                "Active_Flg": "Y",
                                                                                "usedInFE": "N",
                                                                                "c_id": null,
                                                                                "Terraform_Generated_Key": "N",
                                                                                "Key_Location": null,
                                                                                "Key_Vault_Type": null,
                                                                                "Admin_Type": null
                                                                            },
                                                                            {
                                                                                "Id": 1209,
                                                                                "parentId": 1207,
                                                                                "type": "radio",
                                                                                "name": "",
                                                                                "displayComponent": "",
                                                                                "isStart": false,
                                                                                "isEnd": false,
                                                                                "configComponent": "",
                                                                                "conditionNodeType": "",
                                                                                "className": "",
                                                                                "iconUrl": "",
                                                                                "iconBgColor": "",
                                                                                "displayname": "",
                                                                                "category": "",
                                                                                "categoryOptionValue": "",
                                                                                "Record_Typ": "field",
                                                                                "value": "N",
                                                                                "label": "No",
                                                                                "teraFrSameAsValue": "Y",
                                                                                "Active_Flg": "Y",
                                                                                "usedInFE": "N",
                                                                                "c_id": null,
                                                                                "Terraform_Generated_Key": "N",
                                                                                "Key_Location": null,
                                                                                "Key_Vault_Type": null,
                                                                                "Admin_Type": null
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "Id": 1211,
                                                                        "parentId": 1011,
                                                                        "type": "radio",
                                                                        "name": "outlook_sync_all",
                                                                        "displayComponent": "",
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Outlook Sync All",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "DB",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Application",
                                                                        "data": [
                                                                            {
                                                                                "Id": 1214,
                                                                                "parentId": 1211,
                                                                                "type": "radio",
                                                                                "name": "",
                                                                                "displayComponent": "",
                                                                                "isStart": false,
                                                                                "isEnd": false,
                                                                                "configComponent": "",
                                                                                "conditionNodeType": "",
                                                                                "className": "",
                                                                                "iconUrl": "",
                                                                                "iconBgColor": "",
                                                                                "displayname": "",
                                                                                "category": "",
                                                                                "categoryOptionValue": "",
                                                                                "Record_Typ": "field",
                                                                                "value": "Y",
                                                                                "label": "Yes",
                                                                                "teraFrSameAsValue": "Y",
                                                                                "Active_Flg": "Y",
                                                                                "usedInFE": "N",
                                                                                "c_id": null,
                                                                                "Terraform_Generated_Key": "N",
                                                                                "Key_Location": null,
                                                                                "Key_Vault_Type": null,
                                                                                "Admin_Type": null
                                                                            },
                                                                            {
                                                                                "Id": 1215,
                                                                                "parentId": 1211,
                                                                                "type": "radio",
                                                                                "name": "",
                                                                                "displayComponent": "",
                                                                                "isStart": false,
                                                                                "isEnd": false,
                                                                                "configComponent": "",
                                                                                "conditionNodeType": "",
                                                                                "className": "",
                                                                                "iconUrl": "",
                                                                                "iconBgColor": "",
                                                                                "displayname": "",
                                                                                "category": "",
                                                                                "categoryOptionValue": "",
                                                                                "Record_Typ": "field",
                                                                                "value": "N",
                                                                                "label": "No",
                                                                                "teraFrSameAsValue": "Y",
                                                                                "Active_Flg": "Y",
                                                                                "usedInFE": "N",
                                                                                "c_id": null,
                                                                                "Terraform_Generated_Key": "N",
                                                                                "Key_Location": null,
                                                                                "Key_Vault_Type": null,
                                                                                "Admin_Type": null
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "Id": 1428,
                                                                        "parentId": 1011,
                                                                        "type": "text",
                                                                        "name": "sync_type",
                                                                        "displayComponent": null,
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Sync Type",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Global"
                                                                    }
                                                                ],
                                                                "children": [],
                                                                "nodeDetails": {
                                                                    "nodeId": 1011,
                                                                    "parentId": 1008
                                                                },
                                                                "path": [
                                                                    "1",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "3"
                                                                ]
                                                            },
                                                            {
                                                                "id": "node-8489eb83-cbb3-4fd6-a043-b2f8e6d0ca7b",
                                                                "type": "condition",
                                                                "name": "Video",
                                                                "displayName": "Video",
                                                                "className": "feature",
                                                                "iconUrl": "https://adminzing.blob.core.windows.net/icon/Group7886.png",
                                                                "iconBgColor": "#9C27B0",
                                                                "configElements": [
                                                                    {
                                                                        "Id": 1093,
                                                                        "parentId": 1013,
                                                                        "type": "text",
                                                                        "name": "video_meeting_start_end_buffer_hours",
                                                                        "displayComponent": "",
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "Video Meeting Start End Buffer Hours",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Global"
                                                                    },
                                                                    {
                                                                        "Id": 1327,
                                                                        "parentId": 1013,
                                                                        "type": "text",
                                                                        "name": "acs_connection_string",
                                                                        "displayComponent": null,
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "ACS Connection String",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "N",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Global"
                                                                    },
                                                                    {
                                                                        "Id": 1395,
                                                                        "parentId": 1013,
                                                                        "type": "text",
                                                                        "name": "react_app_scheduling_api_base",
                                                                        "displayComponent": null,
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "React App Scheduling API Base",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "Y",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Common",
                                                                        "Admin_Type": "Global"
                                                                    },
                                                                    {
                                                                        "Id": 1397,
                                                                        "parentId": 1013,
                                                                        "type": "text",
                                                                        "name": "react_app_video_app_referer",
                                                                        "displayComponent": null,
                                                                        "isStart": false,
                                                                        "isEnd": false,
                                                                        "configComponent": "",
                                                                        "conditionNodeType": "",
                                                                        "className": "",
                                                                        "iconUrl": "",
                                                                        "iconBgColor": "",
                                                                        "displayname": "React App Video App Referer",
                                                                        "category": "",
                                                                        "categoryOptionValue": "",
                                                                        "Record_Typ": "property",
                                                                        "value": "",
                                                                        "label": "",
                                                                        "teraFrSameAsValue": "Y",
                                                                        "Active_Flg": "Y",
                                                                        "usedInFE": "N",
                                                                        "c_id": null,
                                                                        "Terraform_Generated_Key": "Y",
                                                                        "Key_Location": "keyvault",
                                                                        "Key_Vault_Type": "Client",
                                                                        "Admin_Type": "Global"
                                                                    }
                                                                ],
                                                                "children": [],
                                                                "nodeDetails": {
                                                                    "nodeId": 1013,
                                                                    "parentId": 1008
                                                                },
                                                                "path": [
                                                                    "1",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "0",
                                                                    "children",
                                                                    "4"
                                                                ]
                                                            }
                                                        ],
                                                        "path": [
                                                            "1",
                                                            "children",
                                                            "0",
                                                            "children",
                                                            "0",
                                                            "children",
                                                            "0",
                                                            "children",
                                                            "0",
                                                            "children",
                                                            "0",
                                                            "children",
                                                            "0"
                                                        ]
                                                    }
                                                ],
                                                "nodeDetails": {
                                                    "nodeId": 1008,
                                                    "parentId": 1007
                                                },
                                                "path": [
                                                    "1",
                                                    "children",
                                                    "0",
                                                    "children",
                                                    "0",
                                                    "children",
                                                    "0",
                                                    "children",
                                                    "0",
                                                    "children",
                                                    "0"
                                                ],
                                                "configuring": false
                                            }
                                        ],
                                        "path": [
                                            "1",
                                            "children",
                                            "0",
                                            "children",
                                            "0",
                                            "children",
                                            "0",
                                            "children",
                                            "0"
                                        ]
                                    }
                                ],
                                "nodeDetails": {
                                    "nodeId": 1007,
                                    "parentId": 1006
                                },
                                "path": [
                                    "1",
                                    "children",
                                    "0",
                                    "children",
                                    "0",
                                    "children",
                                    "0"
                                ]
                            }
                        ],
                        "path": [
                            "1",
                            "children",
                            "0",
                            "children",
                            "0"
                        ]
                    }
                ],
                "nodeDetails": {
                    "nodeId": 1006,
                    "parentId": 1000
                },
                "path": [
                    "1",
                    "children",
                    "0"
                ],
                "configuring": false
            }
        ],
        "path": [
            "1"
        ],
        "Id": "1000"
    },
    {
        "Id": 1001,
        "parentId": 0,
        "type": "end",
        "name": "End",
        "displayComponent": "end",
        "isStart": false,
        "isEnd": true,
        "configComponent": "",
        "conditionNodeType": "",
        "className": "",
        "iconUrl": "/static/media/endIcon.894abd1565744e56cd272b27c1be6fb8.svg",
        "iconBgColor": "#6B6B6C",
        "displayname": "End",
        "category": "",
        "categoryOptionValue": "",
        "Record_Typ": "node",
        "value": "",
        "label": "",
        "teraFrSameAsValue": "N",
        "Active_Flg": "Y",
        "usedInFE": "N",
        "c_id": null,
        "Terraform_Generated_Key": "N",
        "Key_Location": null,
        "Key_Vault_Type": null,
        "Admin_Type": null,
        "path": [
            "2"
        ],
        "id": "2"
    }
  ] 

  
  const StartNodeDisplay: React.FC = () => {
    const node = useContext(NodeContext);
    return (
      <div>
        <div className='default-node-label'>{node.name}</div>
        <div className="start-node" style={{backgroundColor: node.iconBgColor?node.iconBgColor:"" }}>
            <div className='node-icon' style={{color: "white",fontSize: "40px" }}>
              <img className='default-node-icon' src={node.iconUrl?node.iconUrl:""} alt="" />
            </div>
          </div>
    </div>
    );
  };
  const [jsonEditorText,setJsonEditorText]=useState([]);

  const [defaultRN,setDefaultRN]=useState<any>([]);
  const [defaultNodes,setDefaultNodes]=useState<any>(sampleNodes);
  const [jsonDataRaw,setJsonDataRaw]=useState<any>([]);
  const [files, setFiles] = useState<any>("");
  const [selectedEnv, setSelectedEnv] = useState<any>("");
  const [EnvList, setEnvList] = useState<any>([]);
  const [InstanceList, setInstanceList] = useState<any>([]);
  const [updateDataList, setUpdateDataList] = useState<any>([]);
  const [openUrlModal, setOpenUrlModal] = useState(false);
  const [confirmModalLoading, setConfirmModalLoading] = useState(false);
  const hiddenFileInput = useRef(null);
  const ActiveClient=useSelector((state:any)=>state.clientDetails.activeClient);
  const [submit,setSubmit]=useState(false)
  const activeClientData=props.data;
  const loadFlowData=props.load_Flow_Data;


  const EndNodeDisplay: React.FC = () => {
    const node = useContext(NodeContext);
    return(
    <div>
      <div className="end-node" style={{backgroundColor: node.iconBgColor?node.iconBgColor:"" }}>
          <div className='node-icon' style={{color: "white",fontSize: "40px" }}>
            <img src={node.iconUrl?node.iconUrl:""} alt="" />
            </div>
          </div>
      <div className='default-node-label'>{node.name}</div>
    </div>
  );
  };

  const NodeDisplay: React.FC = () => {
    const node = useContext(NodeContext);
    return (
      <div
        className={`other-node ${node.configuring ? 'node-configuring' : ''} ${
          node.validateStatusError ? 'node-status-error' : ''
        }`}
      >
        <div className='circle-node'>
        <div className='node-icon' style={{color: "white",fontSize: "32px" }}>
        ❂
              </div>
        </div>
        <div className='label'>{node.data ? node.data.name : node.name}</div>
      </div>
    );
  };

  const ConditionNodeDisplay: React.FC = () => {
    const node = useContext(NodeContext);
    return (
      <div
        className={`condition-node  card ${
          node.configuring ? 'node-configuring' : ''
        } ${node.validateStatusError ? 'node-status-error' : ''}`}
            >
              <div className='card-body'>
                <div className={`icon-section ${node.className?node.className:''}`}  style={{backgroundColor: node.iconBgColor?node.iconBgColor:"" }}>
                  <div className='node-icon' style={{color: "white",fontSize: "40px" }}>
                  <img className='node-icon-img' src={node.iconUrl?node.iconUrl:""} alt="" />
                  </div>
                </div>

                <div className='label'>{node?.data?.displayName?.length > 0 ? node.data.displayName : node?.name}</div>
            </div>
        {/* <div className='label'>{node.data ? node.data.name : node.name}</div> */}
      </div>
    );
  };
  const TestNodeDisplay: React.FC = () => {
    const node = useContext(NodeContext);
    return (
      <div
        className={`condition-node ${
          node.configuring ? 'node-configuring' : ''
        } ${node.validateStatusError ? 'node-status-error' : ''}`}
      >
             <div className='diamond-node'>
              <div className='node-icon' style={{color: "blue",fontSize: "40px" }}>
              ✤
              </div>
             </div>
        <div className='label'>{node.data ? node.data.name : node.name}</div>
      </div>
    );
  };
  
  const loadAllNodes=()=>{
    setNodes(sampleNodesFull)
  }


  const ConfigComp: React.FC = () => {
    return (
    <ConfigForm data={{ load_Flow_Data: true } } onUpdateData={(data:any)=>{
      handleUpdatedInput(data)}}  onChange={(config:any,value:any)=>{if(config.name==="environmentType" ){
        if (value==='Y')
          {
            // loadAllNodes()
          }
          else{
            // setNodes(sampleNodes)
          }
      }}}/>
    );
  };

  const handleUpdatedInput=(data:any)=>{
    for(let i=0;i<data.length;i++){
      const updateObj = data[i];
      setUpdateDataList((prevInputDataArr:any) => {
        // Find the index of the existing object with the same Field_Id
        const index = prevInputDataArr.findIndex((item:any) => item.Field_Id === data[i].Field_Id);
    
        // If the object exists, replace it; otherwise, push the new object
        if (index !== -1) {
          const updatedArr = [...prevInputDataArr];
          updatedArr[index] = updateObj;
          return updatedArr;
        } else {
          return [...prevInputDataArr, updateObj];
        }
      });
    }
  }

  const NodeConmponents:any ={
    start:StartNodeDisplay,
    end:EndNodeDisplay,
    node:NodeDisplay,
    condition:ConditionNodeDisplay,
    testNode:TestNodeDisplay,
    configForm:ConfigComp,
    AutomationConfigPanel:AutomationConfigPanel
  }


  const mapComponent=(data:any)=>{
    let sampleJson:any=[];
    console.log("mapComponent:-",data);
    data.map((item:any) => {
      if(typeof (item.displayComponent) == 'string')
      {

        let component:any=NodeConmponents[item.displayComponent];
        item.displayComponent=component;
      }
      if(typeof (item.configComponent) == 'string')
      {
        let component:any=NodeConmponents[item.configComponent];
        item.configComponent=component;
      }
        sampleJson.push(item);
        return item;
       })

       return sampleJson;

  }

  // const [jsonDataRaw,setJsonDataRaw] = useState(sampleRN);

  // const [defaultRN,setDefaultRN]=useState(newjsonData);





  const setDefaultRNData=()=>{
    // getRNData((res:any)=>{

      console.log("setDefaultRNData::",props.flowRNData);

      let j:any=props.flowRNData;
      let c:any=JSON.parse(JSON.stringify(j));
      let newjsonData :any = mapComponent(c);

      setDefaultRN(newjsonData);
      let doc:any=document;
      let elementValue = doc.getElementById("jsoneditor");
      if(elementValue && elementValue.value.length==0){
        elementValue.value=JSON.stringify(j, null, "\t");
      }

    // });

  }

const getInstanceList=async()=>{
    const fetchedInstance = await getAllClientsList();
    if (Array.isArray(fetchedInstance)) {
        const updatedInstance:any= fetchedInstance?.map((ins:any) => ({
        ...ins,
        value: ins.clientId,
        label: ins.clientName
        }));
        dispatch(setInstanceListData(updatedInstance));
    }
  }





  useEffect(() => {
    const initialPrefrenceObj:any = {};
    dispatch(setPreferences(initialPrefrenceObj));//reseting preference at initial load
    setDefaultRNData();
    if(activeClientData.length>0){
        let selectedEnvValue=activeClientData?.Env_Data[0];
        setSelectedEnv(selectedEnvValue);
        setEnvList(activeClientData.Env_Data);
        console.log("loadFlowData->",loadFlowData,activeClientData,props)
    }
    
      
    if(loadFlowData){
      setNodes(props.flowData);
    }else{
        getDefaultFlow((res: any) => {
          setNodes(res);
        });
    }
    const envPayload={};
     getEnvList(envPayload,(res: any) => {
        if(res?.data)
        {
             const updatedEnvironments = res?.data.map((env:any) => ({
            ...env,
            value: env.Env_Nm,
            label: env.Display_Nm
            }));
            dispatch(setEnvListData(updatedEnvironments));
        }
        });
    getInstanceList();
  }, []);


  useEffect(() => {
    if(loadFlowData){
      setNodes(props.flowData);
    }
 }, [props]);



  async function handleJsonURL() {
    setConfirmModalLoading(true);
    let doc:any=document;
    let url = doc.getElementById("urlField").value;
    let obj:any = await (await fetch(url)).json();
    setConfirmModalLoading(false);
    setOpenUrlModal(false);
    setJsonInputValue(obj);
    setDefaultRN(mapComponent(obj));
    setNodes(defaultNodes);
  }


  const [nodes, setNodes] = useState<INode[]>(defaultNodes);

  const handleChange = (nodes: INode[],chaneEvent:any) => {
    console.log('defaultNodes', nodes,chaneEvent);

    setNodes(nodes);
  };
  const handleChangeEnv = (val:any) => {
    setSelectedEnv(val);
    if(loadFlowData){
      props.getFlowByEnv(val.Env_Id);
    }
  };

  const handleFileInputClick = () => {
    let el:any=hiddenFileInput.current;
    el.click();
  };

  const handleUpdateRegisterNodes=()=>{

    let doc:any=document;
    let elementValue = doc.getElementById("jsoneditor");
    let JsonFormat=JSON.parse(elementValue.value);
    let newJsonData:any=mapComponent(JsonFormat);
    setDefaultRN(newJsonData);
    // console.log("handleUpdateRegisterNodes",defaultNodes);
    let dNodes:any= JSON.parse(JSON.stringify(defaultNodes))
    setNodes(dNodes);


  }
  const setJsonInputValue=(j:any)=>{
    console.log("jval:",j)
    let doc:any=document;
    let elementValue = doc.getElementById("jsoneditor");
      elementValue.value=JSON.stringify(j, null, "\t");
  }
  const handleJsonFileChange=(e:any)=>{
    const fileReader = new FileReader();
    fileReader.readAsText(e.target.files[0], "UTF-8");
    fileReader.onload = e => {
      console.log("e.target.result", e.target?.result);
      setFiles(e.target?.result);
      let s:any=e.target?.result;
      let t:any=JSON.parse(s);
      setJsonInputValue(JSON.parse(s));
      setDefaultRN(mapComponent(t));
      setNodes(defaultNodes);
    };
  }
 const zoomConfig={
  initialValue: 80
 }

 let flowResultArr: any[] = [];
  const exportFlowData=()=>{
    let insertData:any=[];
    let sortOrder=1;
    const creatFlowArray = (flow: any) => {
      
      flow.map((e: any) => {
        if(e.name !=="new branch"){
        let obj: any = {};
        obj.sortOrder=sortOrder++
        obj.name = e.name;
        obj.fbId = e.id;
        obj.nodeId= e.nodeDetails.nodeId;
        obj.parentId= e.nodeDetails.parentId;
        obj.type=e.type;
          if ("data" in e) {
            obj.data = e.data;
            e.configElements.map((x:any)=>{
              if(e.data[x.name]){
                let actValue=e.data[x.name];
                if(x.type!=='text' && x.name!=="selected_env" && x.name!=="clone_instance"){
                  actValue=x.data.filter((y:any)=>y.value==e.data[x.name])[0].Id
                }
                insertData.push({
                  "Field_Id": x.Id,
                  "Field_Type": x.type,
                  "value": actValue,
                  "FB_Id": e.id
                })
              }
              
            })

          }
        flowResultArr.push(obj);
        }
        if (e.children && e.children.length > 0) {
          creatFlowArray(e.children);
        }
      });
    };

    creatFlowArray([nodes[1]]);

    let submitData={
      selectedEnv :selectedEnv,
      flowData:flowResultArr,
      insertData:insertData,
      updateDataList:updateDataList
    }
     setSubmit(!submit)
     props.handleSubmitFlow(submitData);
    

  }


  return (
    <>
    <div className='flowBuilder'>

          {/* <div className='jsonInputSection' style={{width: "25%",marginLeft: "1%",display:"none"}}>
            <div className='jsonInputBtns'>
              <button className="json-button is-fullwidth" title="Upload File" onClick={handleFileInputClick}>
                <input id="fileInput" className="file-input" type="file" ref={hiddenFileInput}  onChange={handleJsonFileChange}/>
                  <span className="json-icon"><UploadOutlined /></span>
                  <span>File</span>
              </button>
              <button className="json-button is-fullwidth" title="Upload File" onClick={()=>setOpenUrlModal(true)}>
                  <span className="json-icon"><LinkOutlined /></span>
                  <span>URL</span>
              </button>
            </div>
            <div className="col-md-6 cardforTextArea h20">
                <div className="cardforTextArea-label cardforTextArea-label-info">Data</div>
                <textarea id="jsoneditor"  name="text" wrap='off' rows={23} cols={40} >
                </textarea>
            </div>
            </div>
            <div className="col-md-6" style={{width: "5%",display:"none"}}>
                <img className="arrowcss" src={arrow} onClick={handleUpdateRegisterNodes}/ >
            </div> */}
            {/* <div className="col-md-6" style={{height:"100%"}}> */}

            <div className='export-flow-btn-section'>

              <div className='export-flow-title pd-md'>
                <div className='pd-md'>Zing Application Flow</div>
              </div>
            <div className='evn-dropdown-div pd-md'>
              { EnvList.length > 1 &&
              <>
                <div className='export-flow-title primary-color pd-md'>Env</div>
                <FormControl fullWidth>

                  {/* <InputLabel id="select-env-label">Env</InputLabel> */}
                  <Select
                    labelId="select-env-label"
                    id="select-env-flow"
                    className="select-env-dropdown"
                    value={selectedEnv}
                    onChange={(e)=>handleChangeEnv(e.target.value)}
                  >
                    { EnvList?.map((items:any) => {
                      return (
                        <MenuItem key={ items.Env_Id } value={items}>{items.Env_Name }</MenuItem>)
                    })}
                  </Select>
                </FormControl>

                </>
                  }
            </div>

              <div className='export-flow-btn-div pd-md'>
                {
                  (loadFlowData || !submit)  &&  <button
                  className="rounded-primary-40 btn font--btn export-flow-btn"
                  type="button"
                  // disabled={loading}
                  onClick={exportFlowData}
                >
                <div>Finish</div>
                  {/* {loading && (
                  <CircularProgress
                      size={24}
                      sx={{
                        color:"inherit",
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: '-12px',
                        marginLeft: '-12px',
                      }}
                    />
                  )} */}
                </button>
                }
               
              </div>

           </div>
                  
                <div className="chartArea">
                {
                    submit && !loadFlowData?<Status />
                    :<FlowBuilder
                    nodes={nodes}
                    onChange={handleChange}
                    registerNodes={defaultRN}
                    CustomNodeComponent={ActionPanel}
                    historyTool
                    zoomTool={zoomConfig}
                  />
                  }
                
                </div>
            {/* </div> */}


        <Modal
        title="Load External URL"
        okText="Load URL"
        open={openUrlModal}
        onOk={handleJsonURL}
        confirmLoading={confirmModalLoading}
        onCancel={()=>setOpenUrlModal(false)}
      >
        <input type="text" className='urlField' id='urlField' placeholder='Enter Url'/>
      </Modal>
      </div>
    </>
  );
};







export default NodeForm;








